import { render, staticRenderFns } from "./userProductList.vue?vue&type=template&id=5f496ea5&"
import script from "./userProductList.vue?vue&type=script&lang=js&"
export * from "./userProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports